import Vue from 'vue'
import Router from 'vue-router'
/* Layout */
import Layout from '@/layout'

/* Router Modules */
Vue.use(Router)

// 忽略重复导航到当前路由的错误
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated') throw err
  })
}

/**
 * Note: sub-menu only appear when route children.length >= 1
 * Detail see: https://panjiachen.github.io/vue-element-admin-site/guide/essentials/router-and-nav.html
 *
 * hidden: true                   if set true, item will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu
 *                                if not set alwaysShow, when item has more than one children route,
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noRedirect           if set noRedirect will no redirect in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
 roles: ['admin','editor']    control the page roles (you can set multiple roles)
 title: 'title'               the name show in sidebar and breadcrumb (recommend set)
 icon: 'svg-name'             the icon show in the sidebar
 noCache: true                if set true, the page will no be cached(default is false)
 affix: true                  if set true, the tag will affix in the tags-view
 breadcrumb: false            if set false, the item will hidden in breadcrumb(default is true)
 activeMenu: '/example/list'  if set path, the sidebar will highlight the path you set
 }
 */

/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 */
export const constantRoutes = [
  {
    path: '/redirect',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '/redirect/:path(.*)',
        component: () => import('@//views/redirect/index')
      }
    ]
  },
  {
    path: '/login',
    component: () => import('@//views/login/index'),
    hidden: true
  },
  {
    path: '/register',
    component: () => import('@//views/login/register'),
    hidden: true
  },
  {
    path: '/forgot-pwd',
    component: () => import('@//views/login/forgot-pwd'),
    hidden: true
  },
  {
    path: '/reset-pwd',
    component: () => import('@//views/login/reset-pwd'),
    hidden: true
  },
  {
    path: '/auth/enter',
    component: () => import('@//views/auth/enter'),
    hidden: true
  }
]


const idDropshipperPrefix = "app-dropshipper-";

export const dropshipperRoutes = [
  {
    path: '/',
    component: Layout,
    redirect: '/dashboard',
    children: [
      {
        path: 'dashboard',
        component: () => import('@//views/dashboard/index'),
        name: 'Dashboard',
        meta: {
          id: idDropshipperPrefix + "dashboard",
          title: 'Dashboard', icon: 'el-icon-data-board', affix: true
        }
      }
    ]
  },

  {
    path: '/policy',
    component: () => import('@//views/policy/index'),
    name: 'Policy'
  },
  {
    path: '/unsubscribe',
    component: () => import('@//views/unsubscribe/index'),
    name: 'Unsubscribe'
  },
  {
    path: '/sourcing',
    component: Layout,
    redirect: '/sourcing/index',
    children: [
      {
        path: 'index',
        component: () => import('@//views/sourcing/index'),
        name: 'Sourcing',
        meta: {
          id: idDropshipperPrefix + "sourcing",
          title: 'Sourcing', icon: 'el-icon-shopping-cart-full', noCache: true
        }
      },
      {
        path: 'add',
        component: () => import('@//views/sourcing/add'),
        name: 'Post Sourcing',
        meta: {
          id: idDropshipperPrefix + "post-sourcing",
          title: 'Post Sourcing', noCache: true,
        },
        hidden: true
      }
    ]
  },
  {
    path: '/product',
    component: Layout,
    redirect: '/product/list',
    alwaysShow: true, // will always show the root menu
    name: 'Manage Products',
    meta: {
      id: idDropshipperPrefix + "manage-products",
      title: 'Manage Products',
      icon: 'el-icon-goods',
      roles: ['admin', 'editor'] // you can set roles in root nav
    },
    children: [
      {
        path: 'list',
        component: () => import('@//views/product/list'),
        name: 'Marketplace',
        meta: {
          id: idDropshipperPrefix + "marketplace",
          title: 'Marketplace', icon: 'el-icon-menu', noCache: true
        }
      },
      {
        path: 'detail/:id?',
        component: () => import('@/../common/Product'),
        name: 'Product Details',
        meta: {
          title: 'Product Details', noCache: true
        },
        hidden: true
      },
      {
        path: 'detail/:id/:affId',
        component: () => import('@/../common/Product'),
        name: 'Product Details Aff',
        meta: {
          title: 'Product Details', noCache: true
        },
        hidden: true
      },
      {
        path: 'import-list',
        component: () => import('@//views/product/import-list'),
        name: 'ImportList',
        meta: {
          id: idDropshipperPrefix + "import-list",
          title: 'Import List', icon: 'el-icon-download', noCache: true
        }
      },
      {
        path: 'my-products',
        component: () => import('@//views/product/my-products'),
        name: 'MyProducts',
        meta: {
          id: idDropshipperPrefix + "my-products",
          title: 'My Products', icon: 'el-icon-collection', noCache: true
        }
      },
      {
        path: 'my-product-detail/:id',
        component: () => import('@//views/product/my-product-detail'),
        name: 'my-product-detail',
        meta: {title: 'Product Details', noCache: true},
        hidden: true
      },
      {
        path: 'my-product-detail/:id/:variantId',
        component: () => import('@//views/product/my-product-detail'),
        name: 'my-product-detail',
        meta: {title: 'Product Details', noCache: true},
        hidden: true
      },
      {
        path: 'private-list',
        component: () => import('@//views/product/list'),
        name: 'PrivateList',
        meta: {
          id: idDropshipperPrefix + "private-list",
          title: 'Private Products', icon: 'el-icon-lock', noCache: true
        }
      },
      {
        path: 'packing-list',
        component: () => import('@//views/product/packing-list'),
        name: 'PackagingList',
        meta: {
          id: idDropshipperPrefix + "product-packing",
          title: 'Product Packaging', icon: 'el-icon-box', noCache: true
        }
      },
    ]
  },
  {
    path: '/inventory',
    component: Layout,
    redirect: '/inventory/purchase-list',
    alwaysShow: true, // will always show the root menu
    name: 'Manage Inventory',
    meta: {
      id: idDropshipperPrefix + "manage-inventory",
      title: 'Manage Inventory',
      icon: 'el-icon-box',
      roles: ['admin', 'editor'] // you can set roles in root nav
    },
    children: [
      {
        path: 'purchase-list',
        component: () => import('@//views/inventory/purchase-list'),
        name: 'PurchaseList',
        meta: {
          id: idDropshipperPrefix + "purchase-list",
          title: 'Purchase List', icon: 'el-icon-shopping-cart-2', noCache: true
        }
      },
      {
        path: 'my-inventory',
        component: () => import('@//views/inventory/my-inventory'),
        name: 'MyInventory',
        meta: {
          id: idDropshipperPrefix + "my-inventory",
          title: 'My Inventory', icon: 'el-icon-s-custom', noCache: true
        }
      },
      {
        path: 'my-inventory-log',
        component: () => import('@//views/inventory/my-inventory-log'),
        name: 'InventoryLog',
        meta: {
          title: 'Inventory List', icon: 'el-icon-list', noCache: true
        },
        hidden: true
      },
      {
        path: 'purchase-detail',
        component: () => import('@//views/inventory/purchase-detail'),
        name: 'Stock Detail',
        meta: {title: 'Stock Detail', icon: 'el-icon-view', noCache: true},
        hidden: true
      },
      {
        path: 'cart-list',
        component: () => import('@//views/inventory/cart-list'),
        name: 'Purchase CartBox',
        meta: {title: 'Purchase CartBox', icon: 'el-icon-shopping-bag-2', noCache: true},
        hidden: true
      }
    ]
  },

  {
    path: '/order',
    component: Layout,
    redirect: '/order/index',
    children: [
      {
        path: 'index',
        component: () => import('@//views/order/index'),
        name: 'OrderList',
        meta: {
          id: idDropshipperPrefix + "manage-orders",
          title: 'Manage Orders', icon: 'el-icon-document-copy', noCache: true
        }
      },
      {
        path: 'merge',
        component: () => import('@//views/order/merge'),
        name: 'order-merge',
        meta: {title: 'Merge Order', icon: 'el-icon-connection', noCache: true},
        hidden: true
      },
      {
        path: 'split/:id',
        component: () => import('@/../common/Order/split'),
        name: 'order-split',
        meta: {title: 'Split Order', noCache: true},
        hidden: true
      },
      {
        path: 'refund/:id',
        component: () => import('@//views/order/order-refund'),
        name: 'order-refund',
        meta: {title: 'Refund', noCache: true},
        hidden: true
      },
      {
        path: 'detail/:id',
        component: () => import('@//views/order/detail'),
        name: 'order-detail',
        meta: {title: 'Detail', noCache: true},
        hidden: true
      },
    ]
  },
  {
    path: '/pay',
    component: Layout,
    redirect: '/pay/index',
    children: [
      {
        path: 'index',
        component: () => import('@/../common/Pay'),
        name: 'index',
        meta: {title: 'Pay', noCache: true},
        hidden: true
      }
    ]
  },

  {
    path: '/store',
    component: Layout,
    redirect: '/store/index',
    children: [
      {
        path: 'index',
        component: () => import('@//views/store/index'),
        name: 'Manage Stores',
        meta: {
          id: idDropshipperPrefix + "manage-stores",
          title: 'Manage Stores', icon: 'el-icon-s-shop', noCache: true
        }
      }
    ]
  },
  {
    path: '/wallet',
    component: Layout,
    redirect: '/wallet/recharge',
    alwaysShow: true,
    name: 'My Wallet',
    meta: {
      id: idDropshipperPrefix + "my-wallet",
      title: 'My Wallet',
      icon: 'el-icon-wallet'
    },
    children: [
      {
        path: 'recharge',
        component: () => import('@//views/wallet/recharge'),
        name: 'Recharge',
        meta: {
          id: idDropshipperPrefix + "recharge",
          title: 'Top-up', icon: 'el-icon-plus', noCache: true
        }
      },
      {
        path: 'recharge/detail/:id',
        component: () => import('@//views/wallet/recharge-detail'),
        name: 'RechargeDetail',
        meta: {title: 'Recharge Detail', noCache: true},
        hidden: true
      },
      {
        path: 'billing-history',
        component: () => import('@//views/wallet/billing-history'),
        name: 'BillingHistory',
        meta: {
          id: idDropshipperPrefix + "billing-history",
          title: 'Billing History', icon: 'el-icon-document', noCache: true
        }
      },
      {
        path: 'cost-breakdown',
        component: () => import('@//views/wallet/cost-breakdown'),
        name: 'CostBreakdown',
        meta: {
          id: idDropshipperPrefix + "cost-breakdown",
          title: 'Cost Breakdown', icon: 'el-icon-pie-chart', noCache: true
        }
      },
      {
        path: 'my-invoice',
        component: () => import('@//views/wallet/my-invoice'),
        name: 'MyInvoice',
        meta: {
          id: idDropshipperPrefix + "my-invoice",
          title: 'Invoicing', icon: 'el-icon-tickets', noCache: true
        }
      },
      {
        path: 'my-invoice/detail/:id',
        component: () => import('@//views/wallet/invoice-detail'),
        name: 'InvoiceDetail',
        meta: {title: 'Invoice Detail', noCache: true},
        hidden: true
      },
      {
        path: 'my-invoice/detail/merged',
        component: () => import('@//views/wallet/invoice-detail'),
        name: 'MergedInvoiceDetail',
        meta: {title: 'Merged Invoice', noCache: true},
        hidden: true
      }
    ]
  },
  {
    path: '/affiliate',
    redirect: '/affiliate/index',
    component: Layout,
    children: [
      {
        path: 'index',
        component: () => import('@//views/affiliate/index'),
        name: 'Affiliate',
        meta: {
          id: idDropshipperPrefix + "affiliate-index",
          title: 'Affiliate', icon: 'el-icon-user', noCache: true
        }
      }
    ]
  },
  {
    path: '/setting',
    redirect: '/setting/general',
    component: Layout,
    alwaysShow: true,
    name: 'Setting',
    meta: {
      id: idDropshipperPrefix + "setting",
      title: 'Settings',
      icon: 'el-icon-setting'
    },
    children: [
      {
        path: 'general',
        component: () => import('@//views/setting/general'),
        name: 'GeneralSetting',
        meta: {
          id: idDropshipperPrefix + "general-setting",
          title: 'General Settings', icon: 'el-icon-s-tools', noCache: true
        }
      },

      {
        path: 'staff',
        component: () => import('@//views/setting/staff'),
        name: 'StaffAccounts',
        meta: {
          id: idDropshipperPrefix + "staff-accounts",
          title: 'Staff Accounts', icon: 'el-icon-user-solid', noCache: true
        }
      },
      {
        path: 'access-key',
        component: () => import('@//views/setting/access-key'),
        name: 'AccessKey',
        meta: {
          id: idDropshipperPrefix + "access-key",
          title: 'API Keys', icon: 'el-icon-key', noCache: true
        }
      },
      {
        path: 'logistics',
        component: () => import('@//views/setting/logistics'),
        name: 'Shipping Calculator',
        meta: {
          id: idDropshipperPrefix + "shipping-calculator",
          title: 'Shipping Calculator', icon: 'el-icon-cpu', noCache: true
        }
      },
      {
        path: 'shipping-rule',
        component: () => import('@//views/setting/shipping-rule'),
        name: 'ShippingRule',
        meta: {
          id: idDropshipperPrefix + "shipping-rule",
          title: 'Shipping Rule', icon: 'el-icon-document', noCache: true
        }
      },
      {
        path: 'shopify-rate-sync',
        component: () => import('@//views/setting/shopify-rate-sync'),
        name: 'ShopifyRateSync',
        meta: {
          id: idDropshipperPrefix + "shopify-rate-sync",
          title: 'Shopify Rate Sync', icon: 'el-icon-truck', noCache: true
        }
      },
      {
        path: 'packing',
        component: () => import('@//views/setting/packing'),
        name: 'Packing',
        meta: {
          id: idDropshipperPrefix + "custom-packing",
          title: 'Custom Packaging', icon: 'el-icon-box', noCache: true
        }
      },
      {
        path: 'packing/add',
        component: () => import('@//views/setting/packing-detail'),
        name: 'PackingAdd',
        meta: {title: 'Packing Add', noCache: true},
        hidden: true
      },
      {
        path: 'packing/detail/:id',
        component: () => import('@//views/setting/packing-detail'),
        name: 'PackingDetail',
        meta: {title: 'Packing Detail', noCache: true},
        hidden: true
      },

    ]
  }
]

const notFound = [
  // 404 page must be placed at the end !!!
  {path: '*', redirect: '/404', hidden: true}
]

const buildRouter = () => {
  return constantRoutes.concat(dropshipperRoutes).concat(notFound)
}
const createRouter = () => new Router({
  // mode: 'history', // require service support
  scrollBehavior: () => ({y: 0}),
  mode: "history",
  routes: buildRouter()
})

const router = createRouter()

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

export default router
